module.exports = __webpack_public_path__ + "static/img/step3.8196ae3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/store/idual/step3.jpg
// module id = 639
// module chunks = 0